import { parseDef } from "../parseDef.js";
export function parsePromiseDef(def, refs) {
    return parseDef(def.type._def, refs);
}
